<template>
    <div class="event">
       <div class="title wow fadeInUp">
            {{$t('about').event.text0}}
       </div>
        <div class="introduce wow fadeInUp">
            {{$t('about').event.text1}}
        </div>
        <div class="allItems" >
        <div class="item wow fadeInUp" :class="{enItem:$i18n.locale==='en'}" v-for="(item,index) in list" :key="index">
<!--        <div class="circle">-->
<!--            <img :src="item.img" alt="">-->
<!--        </div>-->
            <p class="t1">{{item.title}}</p>
            <div  class="box">
                 <p>{{item.content}}</p>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import { getProductsUrl} from '../util/lang'
    export default {
        name: "events",
        data(){
            return{
                list:[
                    {
                        img:require('../assets/ycb/zz.png'),
                        title:'正直',
                        content:'即勇敢、坚定不移、心地坦荡，坚持正道。正直是正瑞的根基，是我们的初心。我们始终坚持初心，总结过去，展望未来。我们仍将以“正直”检验“初心”，以“正直”护卫“初心”，以“正直”解“宽窄”，以“正直”行“宽窄”。'
                    },
                    {
                        img:require('../assets/ycb/cx.png'),
                        title:'诚信',
                        content:'即诚实、守信。是正瑞处世做事的基本原则。正瑞始终将诚信融入科研、生产、经营、管理活动中的全过程，对社会、客户、员工言必行，诺必践，做到内诚外信，以诚信赢得市场，树立良好形象。'
                    },
                    {
                        img:require('../assets/ycb/ws.png'),
                        title:'务实',
                        content:'即说实话、做实事、求实效。是正瑞持续健康发展的基石。务实既是一种态度，更是一种作风，十几年来，正瑞人一直兢兢业业，勤勤恳恳，实事求是、脚踏实地、真抓实干、用实绩说话。'
                    },
                    {
                        img:require('../assets/ycb/cc.png'),
                        title:'创新',
                        content:'只有创新，才有未来。创造是正瑞持续发展的原动力，更是正瑞生存和发展的必然要求。面对日益激烈的市场竞争，正瑞唯有冲破旧思维、打破旧格局、突破旧技术，持续推进管理创新、制度创新和技术创新，才能把握先机、赢得发展主动权。'
                    }
                ]
            }
        },
        mounted(){
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.list=[
                        {
                            img:require('../assets/ycb/zz.png'),
                            title:'Upright',
                            content:'That is to be brave, unwavering, open-hearted, and uphold the right way. Integrity is the foundation of Zhengrui and our original intention. We always adhere to our original intention, summarize the past and look forward to the future. We will still use "integrity" to test the "initial mind", "integrity" to protect the "initial mind", "integrity" to solve the "width" and "integrity" to "width".'
                        },
                        {
                            img:require('../assets/ycb/cx.png'),
                            title:'Integrity',
                            content:'That is honesty and trustworthiness. It is the basic principle of Zhengrui doing things. Zhengrui has always integrated integrity into the whole process of scientific research, production, operation, and management activities. It will do what it says to society, customers, and employees.'
                        },
                        {
                            img:require('../assets/ycb/ws.png'),
                            title:'Pragmatic',
                            content:'That is to tell the truth, do real things, and seek practical results. It is the cornerstone of Zhengrui\'s sustained and healthy development. Pragmatism is not only an attitude, but also a style. For more than ten years, Zhengrui cadres and employees have been conscientious, diligent and diligent, seeking truth from facts, being down-to-earth, practical, and speaking with achievements.'
                        },
                        {
                            img:require('../assets/ycb/cc.png'),
                            title:'Innovation',
                            content:'Only innovation can have a future. Creation is the driving force behind the continuous development of Zhengrui, and it is also an inevitable requirement for the survival and development of Zhengrui. Facing the increasingly fierce market competition, Zhengrui can only grasp the opportunity and win the development initiative by breaking through the old thinking, breaking the old pattern, breaking through the old technology, and continuously promoting management innovation, system innovation and technological innovation.'
                        }
                    ]
                }
                // this.getList('4')
            })
        },
        methods:{
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                        this.$refs.mySwipers2.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .event{
        width:100%;
        background-color: #F7F7F7;
        padding: 60px 0;
        .title{
            width:100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-family: "SOURCEHANSANSCN-BOLD";
            font-size: 30px;
            &::after{
                content:'';
                width:24px;
                height:2px;
                background:rgba(109,45,121,1);
                display: inline-block;
                margin: 20px auto;
            }
        }
        .introduce{
            width:80%;
            margin: 0 auto;
            text-align: center;
            font-family: "SourceHanSansSC-Normal";
            line-height: 31px;
        }
        .allItems{
            width:1440px;
            margin: 60px auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .item{
                width:23%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .circle{
                    width:107px;
                    height:107px;
                    border:1px solid rgba(203,203,203,1);
                    border-radius:50%;
                  display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .t1{
                    font-size: 30px;
                    font-family: "SourceHanSansSC-Normal";
                   margin: 15px auto;
                    transition: all 600ms;
                }
                .box{
                    width:100%;
                    background: linear-gradient(to left, #CBCBCB, #CBCBCB) left top no-repeat,
                    linear-gradient(to bottom, #CBCBCB, #CBCBCB) left top no-repeat,
                    linear-gradient(to left, #CBCBCB, #CBCBCB) right top no-repeat,
                    linear-gradient(to bottom, #CBCBCB, #CBCBCB) right top no-repeat,
                    linear-gradient(to left, #CBCBCB, #CBCBCB) left bottom no-repeat,
                    linear-gradient(to bottom, #CBCBCB, #CBCBCB) left bottom no-repeat,
                    linear-gradient(to left, #CBCBCB, #CBCBCB) right bottom no-repeat,
                    linear-gradient(to left, #CBCBCB, #CBCBCB) right bottom no-repeat;
                    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
                    padding: 30px 0;
                    height:250px;
                    transition: all 600ms;
                    margin: 20px auto;
                    p{
                        width:80%;
                        margin: 0 auto;
                        font-family: "SourceHanSansSC-Normal";
                        line-height: 31px;
                    }
                }
                &:hover{
                    .circle{
                        img{
                            transform: rotateY(360deg);
                        }
                    }
                    .t1{
                        color:#6D2D79;
                    }
                    .box{
                        background-size: 1px 100px, 100px 1px, 1px 100px, 100px 1px;
                    }
                }
            }
            .enItem{
                .box{
                    height:550px;
                }
            }
        }
        @media screen and (max-width: 1440px){
           .allItems{
               width:90%;
           }
        }
        @media screen and (max-width: 1000px){
         padding: 30px 0;
            .title{
                font-size: 20px;
            }
            .introduce{
                width:100%;
            }
            .allItems{
                margin: 30px auto;
                flex-direction: column;
                .item{
                    width:100%;
                    margin-left: 0;
                    .t1{
                        font-size: 20px;
                    }
                    .box{
                        p{
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>
